import { render, staticRenderFns } from "./table-row.project-members.vue?vue&type=template&id=3b00db65&scoped=true&"
import script from "./table-row.project-members.vue?vue&type=script&lang=js&"
export * from "./table-row.project-members.vue?vue&type=script&lang=js&"
import style0 from "./table-row.project-members.vue?vue&type=style&index=0&id=3b00db65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b00db65",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
